export default __webpack_public_path__ + "static/media/head-logo.284112af.jpeg";